import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const DEFAULT_WIDGETS = [
    { id: 'kpi-sales', type: 'kpi', title: 'Sales (TTC)', visible: true, size: 1 },
    { id: 'kpi-net', type: 'kpi', title: 'Net Sales (HT)', visible: true, size: 1 },
    { id: 'kpi-cash', type: 'kpi', title: 'Cash Collected', visible: true, size: 1 },
    { id: 'kpi-invoices', type: 'kpi', title: 'Invoices', visible: true, size: 1 },
    { id: 'chart-trend', type: 'chart', title: 'Weekly Sales Trend', visible: true, size: 2 },
    { id: 'chart-payment', type: 'chart', title: 'Payment Methods', visible: true, size: 1 },
    { id: 'chart-products', type: 'chart', title: 'Top Products', visible: true, size: 1 },
    { id: 'table-recent', type: 'table', title: 'Recent Invoices', visible: true, size: 2 },
    { id: 'system-status', type: 'status', title: 'System Status', visible: true, size: 2 }
];

const useDashboardStore = create(
    persist(
        (set, get) => ({
            isCustomizeMode: false,
            widgets: DEFAULT_WIDGETS,

            toggleCustomizeMode: () => set((state) => ({ isCustomizeMode: !state.isCustomizeMode })),

            setWidgets: (newWidgets) => set({ widgets: newWidgets }),

            toggleWidgetVisibility: (id) => set((state) => ({
                widgets: state.widgets.map(w => w.id === id ? { ...w, visible: !w.visible } : w)
            })),

            toggleWidgetSize: (id) => set((state) => ({
                widgets: state.widgets.map(w => w.id === id ? { ...w, size: w.size === 1 ? 2 : 1 } : w)
            })),

            reorderWidgets: (draggedId, targetId) => {
                const widgets = [...get().widgets];
                const draggedIndex = widgets.findIndex(w => w.id === draggedId);
                const targetIndex = widgets.findIndex(w => w.id === targetId);

                if (draggedIndex === -1 || targetIndex === -1) return;

                const [draggedItem] = widgets.splice(draggedIndex, 1);
                widgets.splice(targetIndex, 0, draggedItem);

                set({ widgets });
            },

            resetLayout: () => set({ widgets: DEFAULT_WIDGETS })
        }),
        {
            name: 'dashboard-layout-storage',
            getStorage: () => localStorage,
        }
    )
);

export default useDashboardStore;
